import { API_ENDPOINTS } from "./Constants";
import { apiFetch } from "./apiHelper";
import { encryptPassword } from "./cryptoHelper";

export async function login(username, password) {
  const encryptedPassword = await encryptPassword(password);
  const res = await fetch(API_ENDPOINTS.LOGIN, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password: encryptedPassword }),
    credentials: "include",
  });

  let data;
  try {
    data = await res.json();
  } catch (error) {
    throw new Error("Backend nije dostupan ili vraća nevažeći odgovor");
  }

  if (!res.ok) {
    throw new Error(data.message || "Neuspješna prijava");
  }

  if (data.token) {
    localStorage.setItem("token", data.token);
  }

  return data;
}


export async function getCurrentUser() {
  const res = await apiFetch(API_ENDPOINTS.ME, {
    method: "GET",
  });

  if (!res.ok) {
    return { authenticated: false };
  }

  return res.json();
}


export const getCurrentUserDetails = async () => {
  const res = await apiFetch(API_ENDPOINTS.ME_DETAILS, { method: 'GET' });
  if (!res.ok) throw new Error('Niste prijavljeni');
  return res.json();
};

export const getUserDetails = async (username) => {
  const res = await apiFetch(API_ENDPOINTS.USER_DETAILS, { method: 'GET' });
  if (!res.ok) throw new Error('Niste prijavljeni');
  return res.json();
};

export async function logout() {
  try {
    await fetch(API_ENDPOINTS.LOGOUT, {
      method: "POST",
      credentials: "include",
    });
  } catch (e) {
  } finally {
    localStorage.removeItem("token");
  }
}

export const register = async (registrationData) => {
  const res = await fetch(API_ENDPOINTS.REGISTER, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(registrationData),
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || 'Greška prilikom registracije');
  }
  return data;
};

export const updateProfile = async (profileData) => {
  const res = await apiFetch(API_ENDPOINTS.USER_DETAILS, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(profileData),
  });

  let data;
  try {
    data = await res.json();
  } catch {
    data = {};
  }

  if (!res.ok) {
    throw new Error(data.message || 'Greška kod ažuriranja profila');
  }
  return data.message ? data : { message: 'Promjene spremljene' };
};
